import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 11.639a4.26 4.26 0 0 1 1.303-3.054A4.51 4.51 0 0 1 6.444 7.32h3.686c.27-.016 4.964-.337 9.436-3.982a1.52 1.52 0 0 1 1.578-.203c.255.116.472.3.623.531s.233.5.233.774v14.4c0 .273-.08.542-.232.773a1.47 1.47 0 0 1-.624.531 1.52 1.52 0 0 1-1.578-.202c-3.497-2.851-7.13-3.669-8.677-3.897v2.854c0 .238-.06.471-.175.68s-.281.388-.484.52l-1.019.66a1.51 1.51 0 0 1-1.352.147 1.5 1.5 0 0 1-.576-.387 1.4 1.4 0 0 1-.33-.6l-1.09-3.992a4.5 4.5 0 0 1-2.76-1.438A4.26 4.26 0 0 1 2 11.638m18.519 7.193V4.439c-3.964 3.232-8.022 4.05-9.63 4.251v5.893c1.606.205 5.663 1.022 9.63 4.249m-12.13.72v.01l1.018-.66v-2.944h-2zm-1.945-5.034h2.963v-5.76H6.444c-.785 0-1.539.304-2.095.844a2.84 2.84 0 0 0-.868 2.037c0 .763.313 1.496.868 2.036.556.54 1.31.843 2.095.843"
    }, null, -1)
  ])))
}
export default { render: render }